import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalHowDoIServiceABookingPage } from 'src/app/model/page/group/iag-portal/iag-portal-how-do-i-service-a-booking-page';
import { Section } from 'src/app/model/shared/section';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-how-do-i-service-a-booking-page',
  templateUrl: './iag-portal-how-do-i-service-a-booking-page.component.html',
  styleUrls: ['./iag-portal-how-do-i-service-a-booking-page.component.scss']
})
export class IagPortalHowDoIServiceABookingPageComponent implements OnInit {
  pageName = 'How do I service a Portal booking?';
  collapsed: boolean[] = [];
  iagPortalHowDoIServiceABookingPage: IagPortalHowDoIServiceABookingPage = {} as IagPortalHowDoIServiceABookingPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-service-booking') {
        this.iagPortalHowDoIServiceABookingPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalHowDoIServiceABookingPage.sections = [];
    this.iagPortalHowDoIServiceABookingPage.noteSections = [];
    this.iagPortalHowDoIServiceABookingPage.aboveDisabilitiesSection = [];
    this.iagPortalHowDoIServiceABookingPage.belowDisabilitiesSection = [];
    this.iagPortalHowDoIServiceABookingPage.disabilitiesSection = [];
    this.iagPortalHowDoIServiceABookingPage.accordianSection = [];
    this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsClickHere = [];
    this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsBody = [];
    this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsSubAccordian = [];

    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalHowDoIServiceABookingPage.banner);
      this.mapPageInfo(resIncludes.items);
      this.mapNoteSections(resIncludes.includes.Entry);
      this.mapaccordianSection(resIncludes.includes.Entry);
      this.mapSections(resIncludes.includes.Entry);
      this.mapDisabilityMenuAccordian(resIncludes.includes.Entry);
    });
  }

  private mapBanner(iagPortalHowDoIServiceABookingPageEntries: Entry<any>[]) {
    iagPortalHowDoIServiceABookingPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.iagPortalHowDoIServiceABookingPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalHowDoIServiceABookingPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalHowDoIServiceABookingPage.banner.url = entry.fields?.url;
      this.iagPortalHowDoIServiceABookingPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalHowDoIServiceABookingPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalHowDoIServiceABookingPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalHowDoIServiceABookingPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
  private mapaccordianSection(iagPortalHowDoIServiceABookingPageEntries: Entry<any>[]) {
    iagPortalHowDoIServiceABookingPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        if (entry.fields['group'] === 'accordian') {
          this.mapEntryToAccordianSection(entry);
        }
      });
  }

  private mapEntryToAccordianSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIServiceABookingPage.accordianSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry?.fields?.['subBody'] as string,
      category: entry.fields['category'] as string
    });
  }

  private mapSections(iagPortalHowDoIServiceABookingPageEntries: Entry<any>[]) {
    iagPortalHowDoIServiceABookingPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    let section: Section = {
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry?.fields?.['subBody'] as string,
      heading: entry.fields['heading'] as string,
      titleColorClass: entry.fields['sectionClass'] as string,
      noteSections: this.iagPortalHowDoIServiceABookingPage.noteSections.filter((noteSection) => noteSection.category === entry.fields['title']),
      accordianSection: this.iagPortalHowDoIServiceABookingPage.accordianSection.filter((noteSection) => noteSection.category === entry.fields['title'])
    };

    this.iagPortalHowDoIServiceABookingPage.sections.push(section);
    this.iagPortalHowDoIServiceABookingPage.aboveDisabilitiesSection = this.iagPortalHowDoIServiceABookingPage.sections.filter((section) => section.group === 'above-disabilities');
    this.iagPortalHowDoIServiceABookingPage.disabilitiesSection = this.iagPortalHowDoIServiceABookingPage.sections.filter((section) => section.group === 'disabilities');
    this.iagPortalHowDoIServiceABookingPage.belowDisabilitiesSection = this.iagPortalHowDoIServiceABookingPage.sections.filter((section) => section.group === 'below-disabilities');
    this.iagPortalHowDoIServiceABookingPage.sections.sort((a, b) => a.order - b.order);
    // console.log('meal', this.iagPortalHowDoIServiceABookingPage.sections);
  }

  private mapNoteSections(res: Entry<any>[]) {
    res
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToNoteSection(entry);
      });
    this.iagPortalHowDoIServiceABookingPage.noteSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToNoteSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIServiceABookingPage.noteSections.push({
      fullTitle: entry.fields['title'] as string,
      title: pageTitle,
      body: entry.fields['body'] as string,
      iconClass: entry.fields['iconClass'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
  }

  private mapDisabilityMenuAccordian(entry: Entry<any>[]) {
    entry
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryTodisabilityMenuAccordian(entry);
      });
  }
  private mapEntryTodisabilityMenuAccordian(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsClickHere.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
    // console.log('table', this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsClickHere);

    this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsBody = this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsClickHere.map((body) => body.body);
    this.disabilityMenuSubAccordian(this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsBody);
  }

  private disabilityMenuSubAccordian(body: any) {
    body.forEach((element: any) => {
      this.mapEntrydisabilityMenuSubAccirdian(element);
    });
  }
  private mapEntrydisabilityMenuSubAccirdian(element: any) {
    element.forEach((element: any) => {
      this.mapEntryToSubAccordian(element.split('@'));
    });
  }
  private mapEntryToSubAccordian(entry: any) {
    this.iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsSubAccordian.push({
      title: entry[0],
      body: entry.pop()
    });
  }

  public toggleCollapsed(index: number) {
    this.collapsed[index] = !this.collapsed[index];
  }

  public getAccordionStyle(index: number) {
    return this.collapsed[index] ? 'not-collapsed' : 'collapsedOne';
  }

  public getActiveStyle(index: number) {
    return this.collapsed[index] ? 'active' : 'title-hover';
  }
  public getArrowIcons(index: number) {
    return this.collapsed[index] ? 'icon-arrowUp' : 'icon-arrowDown';
  }
}
